import {ListItem} from '@domain/common/list-view/list-item';

/**
 * Modèle représentant une relance
 */
export class Relance implements ListItem {
    idRelance: number;
    libellePortee: string;
    titreMessage: string;
    description: string;
    actif: boolean;
    isSelected?: boolean;

    /**
     * Clé unique pour la ListView
     */
    getKey(): number | string {
        return this.idRelance;
    }
}